/** Geometry for the draggable compose panes. Not remembered between visits. */

/**
 * The prompt column width from which the compose footer shows its toggle labels; below it the
 * toggles collapse to icons. The default column is sized to exactly this once the row is measured.
 */
export const FOOTER_LABEL_WIDTH = 600;

export const PANEL_DEFAULTS = {
  /**
   * The prompt column's share of the row by default, when that is wider than `FOOTER_LABEL_WIDTH`: the
   * footer's label width on a narrow row, this share on a wide one (`DEFAULT_COLUMN_WIDTH`).
   */
  horizontal: 0.42,
  /** Share of the prompt column given to the editor. */
  vertical: 0.5,
} as const;

/**
 * Any CSS length, so each minimum can be what it is really about: the prompt
 * column by what the editor needs, the output side by proportion.
 */
export const PANEL_MINIMUMS = {
  promptPane: "360px",
  outputPane: "40%",
  editor: "160px",
  agentOutput: "160px",
} as const;

/**
 * The prompt column's width until the reader moves the divider, as CSS: at least the footer's label width,
 * and `PANEL_DEFAULTS.horizontal` of the row on a wider one. CSS clamps it to the panes' minimums, so the
 * server renders the same layout the client shows, with nothing to measure.
 */
export const DEFAULT_COLUMN_WIDTH = `max(${FOOTER_LABEL_WIDTH}px, ${PANEL_DEFAULTS.horizontal * 100}%)`;
